import type { GetCalendarProviderAccountResponse } from '../types/GetCalendarProviderAccountResponse';
import type { ConnectedAccountRequest } from 'owa-link-account';
import { makePostRequest } from 'owa-ows-gateway';

export function addCalendarProviderAccount(
    request: ConnectedAccountRequest
): Promise<GetCalendarProviderAccountResponse> {
    return makePostRequest(
        'ows/api/beta/calendarProviderAccounts',
        { request },
        undefined /*correlationId*/,
        undefined /*returnFullResponse*/,
        undefined /*customHeaders*/,
        true /*throwServiceError*/
    );
}
